// DEPENDENCIES ---------------------------------------------------------------- //

// import React from 'react';

import { Theme, SvgIcon, useTheme } from '@mui/material';

// TYPES ---------------------------------------------------------------- //

interface TileIconLyftProps {
  size?: number;
  useTileCorrections?: boolean;
}

// COMPONENT ---------------------------------------------------------------- //

const TileIconLyft = ({ size = 24, useTileCorrections = true }: TileIconLyftProps) => {
  const theme = useTheme();
  const clsx = useSxStyles(theme);

  return (
    <SvgIcon sx={useTileCorrections ? clsx.iconWithCorrections : clsx.icon} style={{ fontSize: `${size}px` }}>
      <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 250 175.94'>
        <path
          fill='currentColor'
          d='M137.25,92.15c0-13.44-.09-26.87,0-40.31.09-10,2.09-19.46,7.54-28C153.47,10.28,165.6,2.26,181.73.37c15.05-1.76,28.07,2.79,39.13,12.73a45.24,45.24,0,0,1,14.28,23.58c.47,2,1.3,2.89,3.46,2.74,2.66-.19,5.34,0,8-.06,1.56,0,2.24.53,2.23,2.15q0,16.16,0,32.31c0,1.78-.72,2.34-2.39,2.28a63.28,63.28,0,0,0-7.42.07c-.75.06-2,1-2,1.58a75.44,75.44,0,0,0,.4,11.94c.83,5.69,4.54,9.1,10.11,10.21,2,.39,2.48,1.17,2.47,3,0,10.38-.07,20.77,0,31.15,0,2.17-.72,2.88-2.82,2.71-18.31-1.47-31.88-10.31-40.89-26.24-4.48-7.91-6-16.58-6.12-25.52-.11-11.72,0-23.44,0-35.16,0-8.15-4.63-13.06-12.64-13.46-7.12-.36-12.6,4.39-13.37,12-.37,3.59-.09,7.24-.16,10.86,0,1.77,1.05,1.94,2.43,1.93,4.57,0,9.15.09,13.72-.05,2.17-.07,2.77.74,2.75,2.82q-.12,15.57,0,31.16c0,2.06-.57,2.9-2.74,2.83-4.38-.13-8.77.07-13.14-.09-2.41-.09-3.16.78-3.06,3.12a37.76,37.76,0,0,1-5.76,22c-6.58,10.54-16.55,14.62-28.64,14.33-2.23-.06-2.29-1.45-2.29-3.11Q137.27,113.16,137.25,92.15Z'
        />
        <path
          fill='currentColor'
          d='M56.05,139.55c5.46,1.07,10.51,2.46,15.66,3,7.72.8,15.08-.51,20.6-6.66,1.33-1.48,2-3.58,2.94-5.4l-.78-.49a9.32,9.32,0,0,0-1.51.66c-10.36,6.95-21.3,6.43-32.15,1.82-10-4.24-15-12.75-15.51-23.2-.73-16-.52-32-.66-48-.06-6.48,0-13,0-19.44,0-1.85.59-2.53,2.47-2.52,10.57.06,21.15.09,31.73,0,2.37,0,2.57,1.13,2.57,3q-.06,25.31,0,50.61c0,4.31,1.93,6.71,5.49,7.07,4.24.42,7-2,7-6.28q0-25.59,0-51.18c0-3.7,0-3.7,3.79-3.7,9.91,0,19.82.06,29.73,0,2.4,0,3.35.51,3.34,3.14-.12,29.55.28,59.1-.31,88.64-.3,15.06-6.6,27.87-19.3,36.79-7.33,5.15-15.73,7.41-24.58,8.29-9.2.91-18.19-.27-27.14-2.31-2.41-.55-3.4-1.59-3.35-4.25C56.15,159.26,56.05,149.46,56.05,139.55Z'
        />
        <path
          fill='currentColor'
          d='M50,134.47C35.73,144.33,10.2,140.74,3,118.7A58,58,0,0,1,.16,101.35C-.1,69.72,0,38.09,0,6.46c0-3.69,0-3.69,3.8-3.69,10.09,0,20.19.1,30.28-.07,2.75,0,3.35.91,3.35,3.45q-.11,48.15,0,96.32c0,8.54,1,17,6.09,24.24C45.41,129.42,47.77,131.79,50,134.47Z'
        />
      </svg>
    </SvgIcon>
  );
};

// STYLES ---------------------------------------------------------------- //

const useSxStyles = (theme: Theme) => ({
  icon: {
    display: 'block',
    color: theme.palette.lyft.main,
  },
  iconWithCorrections: {
    display: 'block',
    marginBottom: '-6px',
    fontSize: '26px',
    color: theme.palette.lyft.main,
  },
});

// EXPORT ---------------------------------------------------------------- //

export default TileIconLyft;
